import app from './app.ts';
import { FAnalytics } from '~common/firebase/analytics.ts';

export const kupAnalytics = new FAnalytics(app);
export default kupAnalytics;
